import { api } from "./client";

export interface SubtitleStatus {
  status: "queued" | "running" | "done" | "failed";
  progress?: number;
  stage?: string;
  segments_so_far?: number;
  result?: {
    added: number;
    language: string;
    duration_s: number;
    elapsed_s: number;
    preset: string;
  };
  error?: string;
}

export async function generateSubtitles(params: {
  project_id: number;
  language?: "auto" | "es" | "en" | "fr" | "pt" | "it" | "de";
  style_preset?: "subtle" | "beast" | "simple";
  model_size?: "tiny" | "base" | "small" | "medium";
  replace?: boolean;
}): Promise<{ task_id: string; status: string }> {
  const r = await api.post("/subtitles/generate/", params);
  return r.data;
}

export async function getSubtitleStatus(taskId: string): Promise<SubtitleStatus> {
  const r = await api.get(`/subtitles/status/${taskId}/`);
  return r.data;
}
